import GeneralTranslations from "../../../Common/ModuleTranslations/es";

export default {
  locale: "en",
  name: "Info Legal",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      { fieldName: "hotelTicker", displayName: "Ticker de hotel" },
      { fieldName: "property", displayName: "Tipo de Política" },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      { fieldName: "id" },
      { fieldName: "hotelTicker", displayName: "hotel Ticker" },
      {
        fieldName: "property",
        displayName: "Tipo de Política",
        optionDisplay: {
          PRIVACY_POLICY: { label: "Política de Privacidad" },
          COMMUNICATIONS_POLICY: { label: "Política de Comunicación" },
        },
        helpText:
          "Política de Privacidad: Texto para explicar conformidad con LOPD and GDPR</br>Política de Comunicación: Texto que el usuario leerá para aceptar la recepción de ofertas e información promocional",
      },
      { fieldName: "text", displayName: "Texto" },
    ],
  },
};
